import { Injectable } from '@angular/core';

@Injectable({
    providedIn: "root"
})
export class BMICalculatorService {
    /**
     * Calculating BMI using Metric Units.
     * Link: https://www.calculator.net/bmi-calculator.html
     * @param mass The mass in kilograms (kg).
     * @param height The height in meters (m).
     */
    calculateBMIByMetricUnits = (mass: number, height: number): number => {
        if (mass <= 0 || height <= 0)
            return 0;
        return Number(((mass) / (height * height)).toFixed(2));
    }


    /**
     * Calculating BMI using USC Units.
     * Link: https://www.calculator.net/bmi-calculator.html
     * @param mass The mass in pound (lbs).
     * @param height The height in inches (in).
     */
    calculateBMIByUSCUnits = (mass: number, height: number): number => {
        if (mass <= 0 || height <= 0)
            return 0;

        return Math.round(((703 * mass) / (height * height)) * 100) / 100;
    }
}